import BaseModel from "./base/baseModel";

export default class ConfiguracaoSetorModel extends BaseModel {
    id?: number = null;
    setorNotificacaoEstoqueMinimoId: number = null;
}
